import { CardGrid, CardSkeleton, SkeletonHeader, SkeletonRow, ShimmerBar } from "./style.jsx";

export default function TrendScoutSkeleton({ rows = 5, cards = false }) {
  if (cards) {
    return (
      <CardGrid>
        {Array.from({ length: rows }).map((_, i) => (
          <CardSkeleton key={`c-${i}`} />
        ))}
      </CardGrid>
    );
  }
  return (
    <>
      <SkeletonHeader>
        {Array.from({ length: 6 }).map((_, i) => (
          <ShimmerBar key={`h-${i}`} style={{ height: 10, width: "60%" }} />
        ))}
      </SkeletonHeader>
      {Array.from({ length: rows }).map((_, r) => (
        <SkeletonRow key={`r-${r}`}>
          <div>
            <ShimmerBar style={{ width: "92%" }} />
            <ShimmerBar style={{ width: "60%", marginTop: 8, height: 10 }} />
          </div>
          <div>
            <ShimmerBar style={{ width: "100%" }} />
            <ShimmerBar style={{ width: "70%", marginTop: 8, height: 10 }} />
          </div>
          <ShimmerBar style={{ width: "80%" }} />
          <ShimmerBar style={{ width: "85%" }} />
          <ShimmerBar style={{ width: "55%" }} />
          <ShimmerBar style={{ width: "75%" }} />
        </SkeletonRow>
      ))}
    </>
  );
}
